
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { CompoundButton } from 'office-ui-fabric-react/lib/Button';

import Text from '../../common/client/components/Text';

import { setPageBackground } from '../../utils';
import openFile from '../common/openFile';

const classNames = mergeStyleSets({
    root: {
        height: '100vh',
        padding: 64
    },

    textPanel: {
        paddingTop: 32,
        paddingRight: 32,
        paddingLeft: 32,
        paddingBottom: 16,
        backgroundColor: 'rgb(255, 255, 255, 0.7)',
    },
    textJustify: {
        textAlign: 'justify'
    },
    help: {
        color: "#000000"
    }
});

const BUTTON_STYLES = {
    root: {
        maxWidth: 400
    },
    label: {
        fontSize: 24
    }
};

const LandingPageView = ({
    onNewCalcClick,
    onProcessOpenFile,
    version
}) => {

    React.useEffect(() => {
        setPageBackground('background.jpg');
    }, []);

    const handleNewCalcClick = () => {
        if (onNewCalcClick) {
            onNewCalcClick();
        }
    }

    const handleOpenCalcClick = () => {
        openFile('', handleProcessOpenFile);
    }

    const handleProcessOpenFile = (file) => {
        if (onProcessOpenFile) {
            onProcessOpenFile(file);
        }
    }

    return (
        <Stack verticalFill verticalAlign="top" className={classNames.root} tokens={{childrenGap: 16}}>
            <Stack.Item grow={1} className={classNames.textPanel}>
                <Stack verticalFill tokens={{childrenGap: 32}}>
                    <Stack.Item grow>
                        <Stack tokens={{childrenGap: 32}}>
                            <Text bold mega>Kalkulátor obnovy mezních pásů plužin</Text>
                            <Text bold large className={classNames.textJustify}>Historické plužiny jsou důležitou součástí české krajiny a mají i významné funkce ekologické a protierozní. Tato aplikace umožňuje navrhnout nové mezní pásy pro obnovu plužin a spočítat cenové náklady a objem materiálu na obnovu/nové vystavění mezí. V aplikaci je možné definovat jejich požadované  vlastnosti např. tvar, rozměry, použitý materiál, vegetační pokryv a jiné.</Text>
                            <Text bold large className={classNames.textJustify}>Tento výzkum byl podpořen projektem „Identifikace a ochrana dochovaných pozůstatků historických plužin“, financovaným Ministerstvem kultury ČR v programu NAKI II. (číslo projektu: DG18P02OVV060).</Text>
                        </Stack>
                    </Stack.Item>
                    <Stack.Item>
                        <Stack tokens={{childrenGap: 4}}>
                            <Text bold>Autoři aplikace:</Text>
                            <Text bold>Ideový návrh aplikace: doc. Ing. Kristina Janečková, Ph.D., Ing. arch. Václav Fanta, Ph.D.</Text>
                            <Text bold>Programování: Ing. Pavel Sedlář, Ing. Martin Vlk</Text>
                        </Stack>
                    </Stack.Item>
                    <Stack.Item>
                        <Stack horizontal horizontalAlign="start" verticalAlign="center" tokens={{childrenGap: 32}}>
                            <CompoundButton
                                secondaryText="(spustit aplikaci pro vytvoření nové kalkulace)"
                                styles={BUTTON_STYLES}
                                onClick={handleNewCalcClick}
                                text="Nová kalkulace"
                            />
                            <CompoundButton
                                secondaryText="(spustit aplikaci s existující kalkulací)"
                                styles={BUTTON_STYLES}
                                onClick={handleOpenCalcClick}
                                text="Načíst kalkulaci ze souboru"
                            />
                            <Stack className={classNames.help}>
                                <a className={classNames.help} href="./help.pdf" target="help">Uživatelská příručka</a>
                            </Stack>
                        </Stack>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal>
                    <Stack.Item grow>
                        <Text small color="#999999">Verze: {version}</Text>
                    </Stack.Item>
                    <Stack.Item>
                        <Text small color="#999999">Foto: T. Jůnek</Text>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default LandingPageView;
